import React, { useState } from 'react'
import { trackEvent } from '@fs/zion-analytics'
import { i18n, setLocalePreference } from '@fs/zion-locale'
import { Row, Select, usePageWidth } from '@fs/zion-ui'
import { kebabCase } from 'lodash-es'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

export default function LanguageSelect({ options }) {
  const { t } = useTranslation()
  const [language, setLanguage] = useState(i18n.language)
  const isMobile = usePageWidth()({ default: true, xl: false })

  function handleOnChange(e) {
    const selectedLanguage = e.target.value
    setLanguage(selectedLanguage)
    trackEvent(`select: language-select-${kebabCase(selectedLanguage)}: click`)
    setLocalePreference(selectedLanguage)
  }

  return (
    <Row alignX={isMobile ? 'center' : 'start'}>
      <Select
        value={language}
        onChange={handleOnChange}
        placeholder={t('apac.language-select.placeholder', 'Select a language')}
        options={options}
      />
    </Row>
  )
}

LanguageSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
}
